<template>



</template>

<script>
    export default {
        data(){
            return{

            }
        },
        created: function(){
            const self = this;
            self.FoxRequest(window.settings.api_url + 'index/account/login', {}, function (response) {
                var data = response.data;
                if(data.result.account == ''){
                    self.$router.push("/account/login");
                }else{
                    if (data.result['is_main'] == '1') {
                        if (window.location.href.indexOf("manage") === -1) {
                            window.location.href = "/manage";
                        }
                    } else {
                        window.location.href = "/warehouse";
                        if (window.location.href.indexOf("warehouse") === -1) {
                            window.location.href = "/warehouse";
                        }
                    }
                }
            }, false, true);
        }

    }
</script>

<style scoped>

</style>